import { render, staticRenderFns } from "./RouterButton.vue?vue&type=template&id=2bc589c0&scoped=true&"
import script from "./RouterButton.vue?vue&type=script&lang=js&"
export * from "./RouterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc589c0",
  null
  
)

export default component.exports